module.exports = __webpack_public_path__ + "5fd0b5e1b622800518d2e18d3dab72b7.MP3";